import actionResponse, { ActionResponse } from '@actions/ActionResponse';

/**
 * The failed response for a Questionnaires admin request. When the server explained the rejection, e.g. "Item PHQ4_1
 * needs text", that explanation is the status message so the admin can see what to fix.
 */
export const questionnaireActionError = (err: unknown): ActionResponse => {
  const serverMessage = (err as Error & { cause?: { message?: unknown } }).cause?.message;
  if (typeof serverMessage === 'string' && serverMessage) {
    return actionResponse.Error(serverMessage);
  }
  return actionResponse.HandleError(err);
};
